import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]
  static values = { current: String }

  currentValueChanged() {
    this.stepTargets.forEach((step) => {
      step.hidden = step.dataset.step !== this.currentValue
    })
  }

  show(event) {
    event.preventDefault()
    this.currentValue = event.params.step
  }
}
